import { __exportAll } from "../../_virtual/_rolldown/runtime.js";

//#region src/types/plugins/ModuleFederationPlugin.ts
var ModuleFederationPlugin_exports = /* @__PURE__ */ __exportAll({});

//#endregion
export { ModuleFederationPlugin_exports };
//# sourceMappingURL=ModuleFederationPlugin.js.map